import PopUpBase from '@components/PopUpBase';
import { Box, Button, Stack, Typography } from '@mui/material';
import color from '@theme/Colors';

type Props = {
    open: boolean;
    onClose(): void;
    isActivating: boolean;
    onConfirm(isActiveAllGeoZones?: boolean): void;
};

export default function PopUpCameraStatus({ open, onClose, isActivating, onConfirm }: Props) {
    return (
        <PopUpBase
            open={open}
            onClose={onClose}
            dialogProps={{
                fullWidth: true,
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: '10px',
                        maxWidth: isActivating ? '650px' : '500px',
                    },
                },
            }}
            title={
                <Typography variant="h4" color="error">
                    Warning
                </Typography>
            }
            titleProps={{ '&.MuiDialogTitle-root': { paddingTop: '24px' } }}
            hideConfirm
            hideClose
            desc={
                <Stack mt={1} pb={0.5}>
                    <Typography textAlign="center" fontSize={14}>
                        Are you sure you want to change the status of this camera?
                    </Typography>

                    <Typography fontSize={12} color={color.grey600} textAlign="center">
                        {isActivating
                            ? 'Camera only keeps GeoZones inactive, Activate all activates camera and all associated GeoZones.'
                            : 'All associated GeoZones will also be deactivated.'}
                    </Typography>

                    <Stack mt={3} direction="row" justifyContent="space-between">
                        <Button sx={{ minWidth: { sm: 120 } }} variant="cancel" onClick={onClose}>
                            Cancel
                        </Button>
                        {isActivating ? (
                            <Stack direction="row" spacing={1}>
                                <Button
                                    sx={{ minWidth: { sm: 130 } }}
                                    variant="outlined"
                                    onClick={() => onConfirm(false)}
                                >
                                    Camera only
                                </Button>
                                <Button
                                    sx={{ minWidth: { sm: 130 } }}
                                    variant="contained"
                                    onClick={() => onConfirm(true)}
                                >
                                    Activate all
                                </Button>
                            </Stack>
                        ) : (
                            <Button sx={{ minWidth: { sm: 130 } }} variant="errorOutlined" onClick={() => onConfirm()}>
                                Confirm
                            </Button>
                        )}
                    </Stack>
                </Stack>
            }
        />
    );
}
